import { Button } from '@sm-dashboard/ui-components';
import { useNavigate } from 'react-router-dom';

export const ViewAllAdsButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/tools/business-ads');
  };

  return (
    <Button variant="outlined" onClick={handleClick}>
      לכל המודעות
    </Button>
  );
};
